import React, { Component } from "react";
import AppForm from "../../partials/AppForm";
import AppInput from "../../partials/AppInput";

export class CategorySearch extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.state = {
      fields: [
        {
          name: "name",
          type: "select",
          placeholder: "Category Name",
          options: [],
        },
        {
          name: "createdAt",
          type: "date",
          placeholder: "Created On",
        }
      ],
    };
  }

  componentDidMount() {
    this.getCategories();
  }

  componentDidUpdate(prevProps) {
    if (this.props.api !== prevProps.api && (!this.state.fields[0].options || this.state.fields[0].options.length === 0)) {
      this.getCategories();
    }
  }

  getCategories = () => {
    const api = this.props.api || window.app?.api;
    if (api && api.apiGetMasterCategory) {
      api.apiGetMasterCategory()
        .then((res) => {
          let list = [];
          if (Array.isArray(res)) {
            list = res;
          } else if (Array.isArray(res?.data)) {
            list = res.data;
          } else if (Array.isArray(res?.data?.records)) {
            list = res.data.records;
          } else if (Array.isArray(res?.records)) {
            list = res.records;
          } else if (Array.isArray(res?.lists)) {
            list = res.lists;
          } else if (Array.isArray(res?.data?.lists)) {
            list = res.data.lists;
          }

          let options = [];
          if (list.length > 0) {
            options = list.map((item) => ({
              key: item.name || item._id || item.id,
              label: item.name || item.title || item.category_name || "",
              value: item.name || item._id || item.id,
              name: item.name,
              id: item._id || item.id,
              _id: item._id || item.id,
            }));
          } else if (res?.data?.options && typeof res.data.options === "function") {
            options = res.data.options("name", "name");
          }

          let newFields = this.state.fields.map((field) => {
            if (field.name === "name" || field.name === "category_id") {
              return { ...field, options };
            }
            return field;
          });

          this.setState({ fields: newFields });
        })
        .catch((err) => {
          console.error("Failed to load category list", err);
        });
    }
  };

  trimObjectValues(obj) {
    const trimmedObj = {};
    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        trimmedObj[key] = obj[key].trim();
      } else {
        trimmedObj[key] = obj[key];
      }
    }
    return trimmedObj;
  }

  onSearch = () => {
    let formData = {};
    if (this.refs.form && this.refs.form.form && this.refs.form.form.current) {
      formData = this.refs.form.form.current.getData() || {};
    }

    let stateData = {};
    this.state.fields.forEach((field) => {
      if (field.value !== undefined && field.value !== null && field.value !== "") {
        if (field.type === "select") {
          if (Array.isArray(field.value) && field.value.length > 0) {
            let selected = field.value[0];
            stateData[field.name] = selected.name || selected.label || selected.value || selected.key;
          } else if (typeof field.value === "string") {
            stateData[field.name] = field.value;
          }
        } else if (field.type === "date") {
          let dateVal = field.value;
          if (dateVal) {
            if (typeof dateVal === "string") {
              if (/^\d{4}-\d{2}-\d{2}$/.test(dateVal.trim())) {
                stateData[field.name] = dateVal.trim();
              } else {
                const parsed = new Date(dateVal);
                if (!isNaN(parsed.getTime())) {
                  const y = parsed.getFullYear();
                  const m = String(parsed.getMonth() + 1).padStart(2, '0');
                  const d = String(parsed.getDate()).padStart(2, '0');
                  stateData[field.name] = `${y}-${m}-${d}`;
                } else {
                  stateData[field.name] = dateVal;
                }
              }
            } else if (dateVal.format && typeof dateVal.format === "function") {
              stateData[field.name] = dateVal.format("YYYY-MM-DD");
            } else if (dateVal instanceof Date && !isNaN(dateVal.getTime())) {
              const y = dateVal.getFullYear();
              const m = String(dateVal.getMonth() + 1).padStart(2, '0');
              const d = String(dateVal.getDate()).padStart(2, '0');
              stateData[field.name] = `${y}-${m}-${d}`;
            } else {
              stateData[field.name] = String(dateVal);
            }
          }
        } else {
          stateData[field.name] = field.value;
        }
      }
    });

    let combined = { ...formData, ...stateData };

    if (combined.name || combined.category_id) {
      let rawVal = combined.name || combined.category_id;
      let matchingOption = this.state.fields[0]?.options?.find(
        (opt) =>
          opt.key === rawVal ||
          opt.id === rawVal ||
          opt._id === rawVal ||
          opt.name === rawVal ||
          opt.label === rawVal
      );
      if (matchingOption) {
        combined.name = matchingOption.name || matchingOption.label || matchingOption.key;
      } else {
        combined.name = rawVal;
      }
    }

    delete combined.category_id;
    delete combined.id;
    delete combined._id;

    combined = this.trimObjectValues(combined);
    combined = Object.filter(combined, (val) => val !== undefined && val !== null && val !== "");

    if (this.props.onSearch) {
      this.props.onSearch(combined);
    }
  };

  clearTextData = () => {
    this.setState({
      fields: this.state.fields.map(field => ({ ...field, value: '' }))
    });

    if (this.refs.form && this.refs.form.form && this.refs.form.form.current) {
      this.refs.form.form.current.reset();
    }

    const clearedData = {
      name: "",
      createdAt: "",
    };

    if (this.props.onSearch) {
      this.props.onSearch(clearedData);
    }
  };

  handleInputChange = (i, event) => {
    const newFields = [...this.state.fields];
    if (newFields[i].type !== "select" && newFields[i].type !== "date") {
      newFields[i].value = event?.target ? event.target.value : event;
    } else if (newFields[i].type === "date" && event) {
      newFields[i].value = event;
    } else if (newFields[i].type === "select") {
      newFields[i].value = event;
    }
    this.setState({ fields: newFields });
  };

  render() {
    let { fields } = this.state;
    const nameField = fields.find((f) => f.name === "name" || f.name === "category_id") || fields[0];
    const createdOnField = fields.find((f) => f.name === "createdAt" || f.name === "created_on") || fields[1];
    const nameIndex = fields.findIndex((f) => f.name === "name" || f.name === "category_id");
    const createdOnIndex = fields.findIndex((f) => f.name === "createdAt" || f.name === "created_on");

    return (
      <AppForm className="row filter-row align-items-start mb-3" ref="form">
        <div className="col-12 col-sm-6 col-md-4">
          <label className="fw-bold mb-1 text-muted" style={{ fontSize: '12px' }}>
            {nameField?.placeholder || "Category Name"}
          </label>
          {nameField && (
            <AppInput
              {...nameField}
              placeholder="Select"
              onChange={(event) => this.handleInputChange(nameIndex !== -1 ? nameIndex : 0, event)}
            />
          )}
        </div>

        <div className="col-12 col-sm-6 col-md-4 position-relative">
          <label className="fw-bold mb-1 text-muted" style={{ fontSize: '12px' }}>
            {createdOnField?.placeholder || "Created On"}
          </label>
          {createdOnField && (
            <AppInput
              {...createdOnField}
              placeholder="Select"
              onChange={(event) => this.handleInputChange(createdOnIndex !== -1 ? createdOnIndex : 1, event)}
            />
          )}
          <div className="text-end mt-1">
            <span
              style={{
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '500',
                color: '#ff9800',
                textDecoration: 'underline'
              }}
              onClick={(e) => {
                e.preventDefault();
                this.clearTextData();
              }}
            >
              Clear All
            </span>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-4">
          <label className="fw-bold mb-1 text-muted" style={{ fontSize: '12px', visibility: 'hidden' }}>
            Search
          </label>
          <div className="form-group mb-0">
            <button
              className="btn btn-warning text-white fw-bold w-100"
              onClick={(e) => {
                e.preventDefault();
                this.onSearch();
              }}
              style={{
                backgroundColor: '#ff9800',
                borderColor: '#ff9800',
                height: '38px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              Search
            </button>
          </div>
        </div>
      </AppForm>
    );
  }
}

export default CategorySearch;




